<template>
  <div class="animated fadeIn">
      <SearchBar :title="$t('ROUTE_NAME.Log History')" @filterInput="setFilter"/>
      <div class="logs-table">
        <b-table v-if="logsLoaded" striped hover show-empty :filter="filter" :empty-text="$t('COMMON.NO_RECORD')" responsive="sm" :items="getTrailsData" :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
          <template slot="HEAD_action" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_path" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_location" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_logged_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
        </b-table>
        <b-card v-else>
          <content-placeholders>
          <content-placeholders-img :style="{height: '400px'}" />
          </content-placeholders>
        </b-card>
        <infinite-loading
        :distance="distance"
        spinner="spiral"
        @infinite="infiniteHandler"
        ref="infiniteLoading">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
      <b-modal hide-header-close :title="$t('TRAILS.CUSTOM_DATE_LOGS')" header-bg-variant="light" ref="downloadLogsModal" centered>
        <b-card>
        <b-row class="mb-3">
            <b-col cols="3"> {{ $t('COMMON.DATE_RANGE') }} </b-col>
            <b-col sm="4" class="mt-auto">
              <date-picker range v-model="dateRange" lang="en" format="YYYY-MM-DD" :clearable="false" width="220px" confirm :click="verifyDateRange()"></date-picker>
            </b-col>
          </b-row>
          <p v-if="verifyDays" style="color: red;" >{{ $t('COMMON.MSG_CSV_LOG_DAYS_ERROR') }}</p>
          <p style="text-align: left; color: red;"> * {{ $t('COMMON.MSG_CSV_LOG_DAYS') }}</p>
        </b-card>
        <div slot="modal-footer">
          <b-btn size="sm" variant="secondary" :disabled="verifyDays" @click="download_logs()"> {{ $t('COMMON.GENERATE') }} </b-btn>
          <b-btn size="sm" variant="light" @click="hidedownloadLogsModal"> {{ $t('COMMON.CLOSE') }} </b-btn>
        </div>
      </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '../../router'
import { mapGetters } from 'vuex'
import SearchBar from '../../components/utils/SearchBar'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'audit-trails',
  data () {
    return {
      filter: null,
      trailsData: [],
      logsLoaded: false,
      tableFields: [
        { key: 'email', sortable: true },
        { key: 'action', label: 'COMMON.ACTION', sortable: true },
        { key: 'path', label: 'TRAILS.PATH', sortable: true },
        { key: 'location', label: 'TRAILS.LOCATION', sortable: true },
        { key: 'ip', sortable: true, label: 'IP' },
        { key: 'logged_at', label: 'TRAILS.LOGGED_AT', sortable: true }
      ],
      dateRange: [moment().subtract(1, 'week'), moment()],
      verifyDays: false,
      sortBy: 'id',
      sortDesc: true,
      distance: Infinity,
      lastLogId: -1
    }
  },
  components: {
    SearchBar,
    DatePicker,
    InfiniteLoading
  },
  computed: {
    ...mapGetters(['idToken', 'isAdminRole']),
    getTrailsData () {
      return this.trailsData
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.isAdminRole) {
        router.replace('/Not-Found-404')
      }
    })
  },
  created () {
    this.distance = Infinity
    this.lastLogId = -1
    this.logsLoaded = false
  },
  mounted () {
    this.$root.$on('exportLogs', (status) => {
      this.$refs.downloadLogsModal.show()
    })
    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
  },
  beforeDestroy () {
    this.$root.$off('exportLogs', this.status)
  },
  methods: {
    verifyDateRange () {
      var startDate = moment(this.dateRange[0])
      var endDate = moment(this.dateRange[1])
      var difference = endDate.diff(startDate, 'days')
      if (difference > 31) {
        this.verifyDays = true
      } else {
        this.verifyDays = false
      }
    },
    hidedownloadLogsModal () {
      this.$refs.downloadLogsModal.hide()
    },
    setFilter (filter) {
      this.filter = filter
    },
    infiniteHandler ($state) {
      let params = {
        last_log_id: this.lastLogId
      }
      Vue.axios.get('activity_logs', { headers: { Authorization: `Bearer ${this.idToken}` }, params: params })
        .then(res => {
          let logs = res.data
          if (logs.length > 0) {
            this.trailsData = this.trailsData.slice().concat(logs)
            this.lastLogId = logs[logs.length - 1]['id']
            this.distance = 100
            this.logsLoaded = true
            this.sortBy = 'id'
            this.sortDesc = true
            $state.loaded()
          } else {
            this.distance = 100
            this.logsLoaded = true
            $state.complete()
          }
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    download_logs () {
      let payload = {
        startDate: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        endDate: moment(this.dateRange[1]).format('YYYY-MM-DD')
      }
      Vue.axios.post('activity_logs/download', payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          let csvData = res.data
          let mimeType = 'text/plain'
          let blob = new window.Blob([csvData], { type: mimeType })

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'logs_' + moment().format() + '.csv'
          document.body.appendChild(link)
          link.click()
          this.$refs.downloadLogsModal.hide()
          link.remove()
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .logs-table {
    max-height: 26.5rem;
    overflow-y: scroll;
    border-radius: 0 0 10px 10px;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
</style>


// WEBPACK FOOTER //
// src/views/audits/Trail.vue